import Workspace from './Workspace';
import TopbarWithCmsSidebarTabs from './subcomponents/TopbarWithCmsSidebarTabs';

import './styles.styl';

export { TopbarWithCmsSidebarTabs };

export default Workspace;

/*
    To use the namespaced subcomponents, use them like this:

    <Workspace>
        <Workspace.Topbar>
            <Workspace.Topbar.Title />
        </Workspace.Topbar>
        <Workspace.Content />
        <Workspace.Sidebar>
            <Workspace.Sidebar.TopSection />
            <Workspace.Sidebar.Section />
        </Workspace.Sidebar>
        <Workspace.LoaderOverlay />
    </Workspace>
*/
